import FieldGroup from './FieldGroup';
import HasManyFieldGroup from './HasManyFieldGroup';
import { FieldArray } from 'react-final-form-arrays';

const Section = ({ data, breadCrumbs }) => {
  const { showTitleBar, titleBarCssClass, title, titleCssClass, subTitle, subTitleCssClass, html, fieldGroups } = data;
  return (
    <section>
      {showTitleBar && (
        <header className={titleBarCssClass}>
          {title && <h2 className={titleCssClass}>{title}</h2>}
          {title && <div className="clearfix" />}
          {subTitle && <h3 className={subTitleCssClass}>{subTitle}</h3>}
          {subTitle && <div className="clearfix" />}
        </header>
      )}
      {html}
      {fieldGroups.map((fieldGroup, index) => {
        if (fieldGroup?.hasMany) {
          const fieldGroupName = fieldGroup.name ?? `fieldGroup${index}`;
          return (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <FieldArray key={index} name={fieldGroupName} render={(props) => <HasManyFieldGroup {...props} fieldGroup={fieldGroup} />} />
          );
        }

        // eslint-disable-next-line @eslint-react/no-array-index-key
        return <FieldGroup key={index} data={fieldGroup} breadCrumbs={breadCrumbs} />;
      })}
    </section>
  );
};

export default Section;
